import React from 'react';
import { useLocation } from 'react-use';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';

import Banner from '@/components/Faq/Banner';
import QaList from '@/components/Faq/QaList';
import Layout from '@/components/Layout';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  // Get external data from the file system, API, DB, etc.

  // The value of the `props` key will be
  //  passed to the `Home` component
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'faq', 'path', 'form', 'resources'])),
    },
  };
};

const Faq = () => {
  const { t } = useTranslation(['faq', 'common']);
  const state = useLocation();
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-常见问题-title'),
          description: t('common:seo-常见问题-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-常见问题-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-常见问题-title')}</title>
        <meta name="description" content={t('common:seo-常见问题-description')} />
        <meta name="keywords" content={t('common:seo-常见问题-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-常见问题-title')}
        />
      </Head>
      <div className="mb-[80px] lg:mb-[280px] xl:mb-[280px]">
        <Banner />
        <QaList />
      </div>
    </>
  );
};

export default Faq;

Faq.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
